<template>
    <div>
        <empty-table-message v-if="form == null" />
        <div class="service-document" v-else>
            <div class="header">
                <div class="enterprise-logo">
                    <img class="logo" :src="form.enterpriselogo" alt />
                </div>
                <div class="enterprise-info">
                    <h2>{{ form.rsocial }}</h2>
                    <p>{{ form.endereco }}</p>
                    <p>{{ form.cidade }}</p>
                    <p>{{ form.cep }}</p>
                </div>
                <div class="client-logo">
                    <img
                        class="logo"
                        :src="form.clientlogo ? form.clientlogo : form.enterpriselogo"
                        alt
                    />
                </div>
                <div class="report-title">
                    <h1>
                        {{
                            $t('atendimento') +
                            ': ' +
                            form.idatendimento +
                            ' - ' +
                            $t('formulario') +
                            ': ' +
                            form.formulario
                        }}
                    </h1>
                </div>
            </div>
            <div class="form">
                <div class="form-gp" v-for="(d, i) in form.grupopergunta" :key="i">
                    <div class="separator">
                        {{ d.titulogrupopergunta }}
                    </div>
                    <div class="question-block" v-for="(p, j) in d.pergunta" :key="j">
                        <div class="question">{{ p.titulopergunta }}</div>
                        <div class="answer">{{ p.resposta }}</div>
                        <div class="option" v-if="p.fotos">
                            <div class="opt-img-block" v-for="(o, k) in p.respostafoto" :key="k">
                                <div v-if="o.type == 'assinatura'">
                                    <div class="opt-img">
                                        <img :src="p.path" alt />
                                    </div>
                                    <div class="opt-legend">
                                        {{ p.nome }}
                                    </div>
                                    <div class="opt-obs">
                                        {{ p.observacao }}
                                    </div>
                                </div>
                                <div v-if="o.type == 'motivo-foto'">
                                    <div class="opt-img">
                                        <img :src="o.path" alt />
                                    </div>
                                    <div class="opt-legend">
                                        <div class="opt-text">
                                            <p>
                                                {{ o.nome }} <br />
                                                {{ getData(o.datahora) }}
                                            </p>
                                            <p>{{ o.obs }}</p>
                                        </div>
                                        <div class="icon-location">
                                            <svg
                                                class="svg-icons"
                                                v-if="p.lat || (p.lat != 0 && p.lng) || p.lng != 0"
                                            >
                                                <use
                                                    :xlink:href="
                                                        require('@/assets/img/icons/crosshairs-gps.svg') +
                                                        '#layer'
                                                    "
                                                ></use>
                                            </svg>
                                            <svg
                                                class="svg-icons"
                                                v-if="
                                                    !(p.lat || (p.lat != 0 && p.lng) || p.lng != 0)
                                                "
                                            >
                                                <use
                                                    :xlink:href="
                                                        require('@/assets/img/icons/crosshairs.svg') +
                                                        '#layer'
                                                    "
                                                ></use>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ProAtendimentoService from '@/services/promotor/ProAtendimentoService.js';

export default {
    props: {
        idatendimento: {
            type: Number,
            default: 0,
        },
        idformulario: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            form: null,
        };
    },
    created() {
        this.service = new ProAtendimentoService(this.$http, this.$router);
        if (this.$route.name == 'promotor-atendimento-form-view') {
            this.loadForm(this.$route.params.idatendimento, this.$route.params.idformulario);
        } else {
            this.loadForm(this.idatendimento, this.idformulario);
        }
    },
    methods: {
        loadForm(idatendimento, idformulario) {
            this.service.getDetailForm(idatendimento, idformulario).then((res) => {
                this.form = res[0];
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.service-document {
    background: $sovis-white;
    height: 100%;
    padding: 20px;

    .header {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        height: auto;

        .enterprise-logo,
        .client-logo {
            width: 15%;
            text-align: center;
            object-fit: cover;
            align-items: center;
            display: flex;
            justify-content: center;

            .logo {
                height: auto;
                max-height: 80px;
            }
        }
        .enterprise-info {
            width: 65%;
            text-align: center;
            margin-bottom: 20px;

            h2 {
                text-align: center;
                font-size: 18px;
                font-weight: 600;
            }
            p {
                font-size: 12px;
                margin-bottom: 5px;
            }
        }
        .report-title {
            font-size: 20px;
            margin-bottom: 10px;
            margin-top: 20px;

            h1 {
                font-weight: 600;
            }
        }
    }

    .form {
        width: 100%;

        .form-gp {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            margin-bottom: 20px;

            .separator {
                width: 100%;
                border-top: 1px solid $table-border;
                border-bottom: 1px solid $table-border;
                padding: 10px 0;
                text-align: center;
                margin-bottom: 10px;
                font-weight: 600;
                font-size: 18px;
            }

            .question-block {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .question {
                    font-weight: 600;
                }

                .question,
                .answer {
                    width: 50%;
                    margin-bottom: 5px;
                    font-size: 14px;
                }
                .option {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    margin-top: 5px;

                    .opt-img-block {
                        margin-right: 20px;
                        width: 250px;

                        .opt-img img {
                            height: auto;

                            &.assinatura {
                                border-bottom: 2px solid $sovis-black;
                            }
                        }

                        .opt-legend,
                        .opt-obs {
                            font-size: 12px;
                            display: flex;
                            justify-content: space-between;
                            margin-top: 5px;

                            p {
                                width: 75%;
                            }
                            .icon-location {
                                width: 25%;
                                text-align: right;
                                .svg-icons {
                                    width: 30px;
                                    height: 30px;
                                }
                            }
                        }
                    }
                }
            }
        }

        .assinatura {
            .opt-img {
                width: 350px;
                margin-right: 20px;
                height: auto;
            }
        }
    }
}
</style>
